/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MerchantList,
    MerchantListFromJSON,
    MerchantListFromJSONTyped,
    MerchantListToJSON,
} from './';

/**
 * 
 * @export
 * @interface MerchantListGroup
 */
export interface MerchantListGroup {
    /**
     * 
     * @type {string}
     * @memberof MerchantListGroup
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MerchantListGroup
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MerchantListGroup
     */
    description?: string;
    /**
     * 
     * @type {Array<MerchantList>}
     * @memberof MerchantListGroup
     */
    merchantLists: Array<MerchantList>;
}

export function MerchantListGroupFromJSON(json: any): MerchantListGroup {
    return MerchantListGroupFromJSONTyped(json, false);
}

export function MerchantListGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): MerchantListGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'merchantLists': ((json['merchantLists'] as Array<any>).map(MerchantListFromJSON)),
    };
}

export function MerchantListGroupToJSON(value?: MerchantListGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'merchantLists': ((value.merchantLists as Array<any>).map(MerchantListToJSON)),
    };
}


